import type { Contract } from './contract.model';

// Asset model for asset list feature
export interface Asset {
	// Java DTO fields
	id?: string;
	extractId?: number;
	scheduleNo?: string;
	contract?: Contract; // Replace 'any' with Contract type if available
	assetId?: string;
	assetNumber?: string;
	instItemAssetId?: string;
	releaseAssetId?: number;
	releaseToSchedule?: string;
	releaseYn?: string;
	itemDescription?: string;
	assetStatus?: string;
	currency?: string;
	purchasePrice?: number;
	rent?: number;
	lastBilledDate?: string;
	purchaseOrder?: string;
	supplierName?: string;
	supplierInvoiceNo?: string;
	supplierInvoiceDate?: string;
	assetCategory?: string;
	assetStartDate?: string;
	assetEndDate?: string;
	serialNumber?: string;
	make?: string;
	model?: string;
	billingAddress1?: string;
	billingAddress2?: string;
	billingAddress3?: string;
	billingAddress4?: string;
	billingCity?: string;
	billingPostalCode?: string;
	billingState?: string;
	billingProvince?: string;
	billingCounty?: string;
	billingCountry?: string;
	installAddress1?: string;
	installAddress2?: string;
	installAddress3?: string;
	installAddress4?: string;
	installCity?: string;
	installPostalCode?: string;
	installState?: string;
	installProvince?: string;
	installCounty?: string;
	installCountry?: string;
	dateReturned?: string;
	dateTerminated?: string;
	terminationType?: string;
	createdBy?: any; // Replace 'any' with Customer type if available
	creationDate?: string;
	lastUpdatedBy?: any; // Replace 'any' with Customer type if available
	lastUpdateDate?: string;
	lastUpdateLogin?: number;
	origAssetId?: number;
	origAssetNumber?: string;
	udf1?: string;
	udf2?: string;
	udf3?: string;
	udf4?: string;
	udf5?: string;
	udf6?: string;
	udf7?: string;
	udf8?: string;
	udf9?: string;
	udf10?: string;
	udf11?: string;
	udf12?: string;
	udf13?: string;
	udf14?: string;
	udf15?: string;
	splitDate?: string;

	// Contract Fields Normalized
	contract_purchaseOrderNumber?: string;
	contract_contractNumber?: string;
	contract_eotOption?: string;

	sourceName?: string;
	sourceId?: number;
}

export interface UserDefinedFieldHeadings {
	udf1?: string;
	udf2?: string;
	udf3?: string;
	udf4?: string;
	udf5?: string;
	udf6?: string;
	udf7?: string;
	udf8?: string;
	udf9?: string;
	udf10?: string;
	udf11?: string;
	udf12?: string;
	udf13?: string;
	udf14?: string;
	udf15?: string;
}

export interface UserDefinedFieldValues extends UserDefinedFieldHeadings {}

export enum NonLeasedAssetBulkEndpointByUpdateType {
	'add' = 'non-leased-assets/upload',
	'edit' = 'non-leased-assets/upload/update'
}